import React, { useEffect } from 'react';

export function useOutsideClick(
  ref: React.MutableRefObject<HTMLDivElement | null>,
  callback: (event: MouseEvent) => void,
) {
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as HTMLDivElement)) {
        callback(event);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [callback, ref]);
}
